import { apiGatewayUtils } from "./apiGatewayUtils";
import { apiGatewayClientFactory } from "./apiGatewayClientFactory";
import { parse } from 'uritemplate'

export const apigClientFactory = {
  newClient: function (config) {
    var apigClient = {};
    if (config === undefined) {
      config = {
        accessKey: "",
        secretKey: "",
        sessionToken: "",
        region: "",
        apiKey: undefined,
        defaultContentType: "application/json",
        defaultAcceptType: "application/json",
        invokeUrl: "https://0bfvxaa1h8.execute-api.us-east-1.amazonaws.com/dev",
      };
    }
    if (config.accessKey === undefined) {
      config.accessKey = "";
    }
    if (config.secretKey === undefined) {
      config.secretKey = "";
    }
    if (config.apiKey === undefined) {
      config.apiKey = "";
    }
    if (config.sessionToken === undefined) {
      config.sessionToken = "";
    }
    if (config.region === undefined) {
      config.region = "us-east-1";
    }
    if (config.invokeUrl === undefined) {
      config.invokeUrl =
        "https://0bfvxaa1h8.execute-api.us-east-1.amazonaws.com/dev";
    }
    //If defaultContentType is not defined then default to application/json
    if (config.defaultContentType === undefined) {
      config.defaultContentType = "application/json";
    }
    //If defaultAcceptType is not defined then default to application/json
    if (config.defaultAcceptType === undefined) {
      config.defaultAcceptType = "application/json";
    }

    // extract endpoint and path from url
    var invokeUrl = config.invokeUrl;
    var endpoint = /(^https?:\/\/[^/]+)/g.exec(invokeUrl)[1];
    var pathComponent = invokeUrl.substring(endpoint.length);

    var sigV4ClientConfig = {
      accessKey: config.accessKey,
      secretKey: config.secretKey,
      sessionToken: config.sessionToken,
      serviceName: "execute-api",
      region: config.region,
      endpoint: endpoint,
      defaultContentType: config.defaultContentType,
      defaultAcceptType: config.defaultAcceptType,
    };

    var authType = "NONE";
    if (
      sigV4ClientConfig.accessKey !== undefined &&
      sigV4ClientConfig.accessKey !== "" &&
      sigV4ClientConfig.secretKey !== undefined &&
      sigV4ClientConfig.secretKey !== ""
    ) {
      authType = "AWS_IAM";
    }

    var simpleHttpClientConfig = {
      endpoint: endpoint,
      defaultContentType: config.defaultContentType,
      defaultAcceptType: config.defaultAcceptType,
    };

    var apiGatewayClient = apiGatewayClientFactory.newClient(
      simpleHttpClientConfig,
      sigV4ClientConfig
    );

    apigClient.authenticateOptions = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var authenticateOptionsRequest = {
        verb: "options".toUpperCase(),
        path:
          pathComponent +
          parse("/authenticate").expand(
            apiGatewayUtils.parseParametersToObject(params, [])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, []),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        authenticateOptionsRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.downloadAwardDocumentGet = function (
      params,
      body,
      additionalParams
    ) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(
        params,
        [],
        ["id", "award_id", "document_id"]
      );

      var downloadAwardDocumentGetRequest = {
        verb: "get".toUpperCase(),
        path:
          pathComponent +
          parse(
            "/employees/{id}/award/{award_id}/document/{document_id}"
          ).expand(
            apiGatewayUtils.parseParametersToObject(params, [
              "id",
              "award_id",
              "document_id",
            ])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
          "responseType",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        downloadAwardDocumentGetRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.configurationGet = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var configurationGetRequest = {
        verb: "get".toUpperCase(),
        path:
          pathComponent +
          parse("/configurations").expand(
            apiGatewayUtils.parseParametersToObject(params, [])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        configurationGetRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.configurationOptions = function (
      params,
      body,
      additionalParams
    ) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var configurationOptionsRequest = {
        verb: "options".toUpperCase(),
        path:
          pathComponent +
          parse("/configurations").expand(
            apiGatewayUtils.parseParametersToObject(params, [])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, []),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        configurationOptionsRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.employeeIdGet = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, ["id"], ["body"]);

      var employeeIdGetRequest = {
        verb: "get".toUpperCase(),
        path:
          pathComponent +
          parse("/employees/{id}").expand(
            apiGatewayUtils.parseParametersToObject(params, ["id"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        employeeIdGetRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.employeeIdOptions = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, ["id"], ["body"]);

      var employeeIdOptionsRequest = {
        verb: "options".toUpperCase(),
        path:
          pathComponent +
          parse("/employees/{id}").expand(
            apiGatewayUtils.parseParametersToObject(params, ["id"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        employeeIdOptionsRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.staticContentOptions = function (
      params,
      body,
      additionalParams
    ) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var staticContentOptionsRequest = {
        verb: "options".toUpperCase(),
        path:
          pathComponent +
          parse("/static_content").expand(
            apiGatewayUtils.parseParametersToObject(params, [])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
          "responseType",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        staticContentOptionsRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.staticContentLanguageGet = function (
      params,
      body,
      additionalParams
    ) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, ["language"], ["body"]);

      var staticContentLanguageGetRequest = {
        verb: "get".toUpperCase(),
        path:
          pathComponent +
          parse("/static_content/{language}").expand(
            apiGatewayUtils.parseParametersToObject(params, ["language"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        staticContentLanguageGetRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.staticContentLanguageOptions = function (
      params,
      body,
      additionalParams
    ) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var staticContentLanguageOptionsRequest = {
        verb: "options".toUpperCase(),
        path:
          pathComponent +
          parse("/static_content/{language}").expand(
            apiGatewayUtils.parseParametersToObject(params, [])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        staticContentLanguageOptionsRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.changeLanguagePut = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var staticContentLanguageOptionsRequest = {
        verb: "put".toUpperCase(),
        path:
          pathComponent +
          parse("/employees/{id}/language/{language}").expand(
            apiGatewayUtils.parseParametersToObject(params, ["id", "language"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        staticContentLanguageOptionsRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.changeBrokerPut = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var changeBrokerPutRequest = {
        verb: "put".toUpperCase(),
        path:
          pathComponent +
          parse("/employees/{id}/broker/{broker_code}").expand(
            apiGatewayUtils.parseParametersToObject(params, [
              "id",
              "broker_code",
            ])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        changeBrokerPutRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.removeBrokerDelete = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var removeBrokerDeleteRequest = {
        verb: "delete".toUpperCase(),
        path:
          pathComponent +
          parse("/employees/{id}/broker/{broker_code}").expand(
            apiGatewayUtils.parseParametersToObject(params, [
              "id",
              "broker_code",
            ])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        removeBrokerDeleteRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.impersonateUserPost = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var impersonateEmployeePostRequest = {
        verb: "post".toUpperCase(),
        path:
          pathComponent +
          parse("/impersonate/{id}").expand(
            apiGatewayUtils.parseParametersToObject(params, ["id"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        impersonateEmployeePostRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.impersonateUserDelete = function (
      params,
      body,
      additionalParams
    ) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var impersonateEmployeeDelete = {
        verb: "delete".toUpperCase(),
        path:
          pathComponent +
          parse("/impersonate/{id}").expand(
            apiGatewayUtils.parseParametersToObject(params, ["id"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, []),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        impersonateEmployeeDelete,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.acceptAwardPut = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var acceptAwardPutRequest = {
        verb: "put".toUpperCase(),
        path:
          pathComponent +
          parse("/employees/{id}/award/{award_id}").expand(
            apiGatewayUtils.parseParametersToObject(params, ["id", "award_id"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        queryParams: apiGatewayUtils.parseParametersToObject(params, [
          "accept_terms",
        ]),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        acceptAwardPutRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.changeTaxPut = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var changeTaxRateOptionsRequest = {
        verb: "put".toUpperCase(),
        path:
          pathComponent +
          parse("/employees/{id}/taxes").expand(
            apiGatewayUtils.parseParametersToObject(params, ["id"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        changeTaxRateOptionsRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    apigClient.changeFractionalPut = function (params, body, additionalParams) {
      if (additionalParams === undefined) {
        additionalParams = {};
      }

      apiGatewayUtils.assertParametersDefined(params, [], ["body"]);

      var changeFractionalOptionsRequest = {
        verb: "put".toUpperCase(),
        path:
          pathComponent +
          parse("/employees/{id}/fractional_elections").expand(
            apiGatewayUtils.parseParametersToObject(params, ["id"])
          ),
        headers: apiGatewayUtils.parseParametersToObject(params, [
          "Authorization",
        ]),
        body: body,
      };

      return apiGatewayClient.makeRequest(
        changeFractionalOptionsRequest,
        authType,
        additionalParams,
        config.apiKey
      );
    };

    return apigClient;
  },
};
